import { render, staticRenderFns } from "./taxi.vue?vue&type=template&id=694400d8&scoped=true&"
import script from "./taxi.vue?vue&type=script&lang=js&"
export * from "./taxi.vue?vue&type=script&lang=js&"
import style0 from "./taxi.vue?vue&type=style&index=0&id=694400d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694400d8",
  null
  
)

export default component.exports